module.exports = __webpack_public_path__ + "img/gopay.58d83dc1.svg";